import {
  Box,
  Button,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../../components/Header";
import { AssetFinanceUrl } from "../../../../config";
import { executeDynamicSubmit } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const Form = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const initialValues = {
    name: props.data ? props.data.Name : "",
    registrationNo: props.data ? props.data.RegistrationNo : "",
    contactEmail: props.data ? props.data.ContactEmail : "",
    contactPhone: props.data ? props.data.ContactPhone : "",
    notes: props.data ? props.data.Notes : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    registrationNo: yup.string().nullable(),
    contactEmail: yup
      .string()
      .test("is-valid-email", "Enter a valid email (e.g. name@domain.com)", (value) => {
        if (!value) return true;
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
      })
      .nullable(),
    contactPhone: yup
      .string()
      .test("is-valid-phone", "Enter a valid phone number (e.g. +254712345678)", (value) => {
        if (!value) return true;
        return /^\+254[17]\d{8}$/.test(value);
      })
      .nullable(),
    notes: yup.string().nullable(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const valuerFirm = {
      name: values.name,
      registrationNo: values.registrationNo || "",
      contactEmail: values.contactEmail || "",
      contactPhone: values.contactPhone || "",
      notes: values.notes || "",
      companyId: parseInt(decodedToken.CompanyId),
    };

    if (props.isEditing) {
      valuerFirm.id = props.data.Id;
      valuerFirm.isApproved = props.data.IsApproved;
      valuerFirm.approvedAt = props.data.ApprovedAt;
      valuerFirm.approvedBy = props.data.ApprovedBy;
    } else {
      valuerFirm.isApproved = false;
    }

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateValuerFirm" : "createValuerFirm",
      variables: valuerFirm,
      mutationObjectName: "valuerFirm",
      baseUrl: base_url,
      isEditing: props.isEditing,
      entityName: "Valuer Firm",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Valuer Firm" : "Create Valuer Firm"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Valuer Firm"
            : "Create a New Valuer Firm"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Name*"
                placeholder="e.g. Oak Valuers Ltd"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Registration No"
                placeholder="e.g. REG-12345"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.registrationNo}
                name="registrationNo"
                error={touched.registrationNo && !!errors.registrationNo}
                helperText={touched.registrationNo && errors.registrationNo}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="email"
                label="Contact Email"
                placeholder="e.g. contact@valuerfirm.com"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactEmail}
                name="contactEmail"
                error={touched.contactEmail && !!errors.contactEmail}
                helperText={touched.contactEmail && errors.contactEmail}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Phone"
                placeholder="e.g. +254712345678"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactPhone}
                name="contactPhone"
                error={touched.contactPhone && !!errors.contactPhone}
                helperText={touched.contactPhone && errors.contactPhone}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                multiline
                minRows={3}
                variant="filled"
                type="text"
                label="Notes"
                placeholder="Valuer Firm notes..."
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.notes}
                name="notes"
                error={touched.notes && !!errors.notes}
                helperText={touched.notes && errors.notes}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Form;
